// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Ce-z","sponsoredTooltipWrapper":"De-z","sponsoredTooltip":"Ee-z","newCard":"Fe-z"};